import { styled } from '../../theme';
import { AnchorButton } from '../AnchorButton/AnchorButton';

export const WhiteRegisterButton = styled(AnchorButton).attrs((props) => ({
	...props,
	variant: 'white',
	text: 'Gå med',
	to: { local: '/register' },
}))``;
